var cilText = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='440 168 440 88 72 88 72 168 104 168 136 168 136 120 224 120 224 400 168 400 168 432 344 432 344 400 288 400 288 120 376 120 376 168 408 168 440 168' class='ci-primary'/>"];

export { cilText };
//# sourceMappingURL=cil-text.js.map
